import React from "react";
import { Loader, Button, Icon, Image } from "semantic-ui-react";
import useLogin from "@common/components/hooks/useLogin";

// Hooks
import useUploadedImageList from "@common/components/hooks/useUploadedImageList";

const UploadedImageList = ({ incidentId }) => {
  const { loadingImages, imageList, handleView, handleDelete } =
    useUploadedImageList({ incidentId });

  const [{ isInReadMode }] = useLogin();

  return (
    <div className="py-1">
      {loadingImages ? (
        <Loader active inline="centered" />
      ) : (
        <>
          <p className="m-0">
            <strong>CCTV Images</strong>
          </p>
          <>
            {imageList.length > 0 ? (
              imageList.map((image) => (
                <div className="flex-between border-bottom py-1" key={image.id}>
                  <div className="flex-row-center">
                    <Image
                      src={`data:image/jpg;base64,${image.thumbnail}`}
                      size="tiny"
                    />
                    <p className="m-0 p-0 align-center">{image.fileName}</p>
                  </div>
                  <div className="flex-row-center">
                    <Button
                      type="button"
                      onClick={() => handleView(image.id, image.fileName)}
                    >
                      View
                    </Button>
                    {!isInReadMode && (
                      <Button
                        type="button"
                        icon
                        onClick={() => handleDelete(image.id)}
                      >
                        <Icon name="cancel" color="red" />
                      </Button>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p>No CCTV Images Uploaded</p>
            )}
          </>
        </>
      )}
    </div>
  );
};

export default UploadedImageList;
